import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import customAxios from '../../util/Api';
import authHeader from '../../../../services/auth/jwt/auth-header';
import { useToast } from 'context/tostifyContext';
import { event } from 'jquery';
import { useAllUsers } from 'context/AllUserDataContext';
import useConfirmationDialog from 'routes/Pages/components/ConfirmDialogs/useConfirmationDialog';

const usePurchaseRequisitionController = () => {
  const [purchaseReqData, setPurchaseReqData] = useState([]);
  const [currentTabPurchaseReqData, setCurrentTabPurchsaseReqData] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const dispatch = useDispatch();

  // add purchase req form
  const [selectedPurchaseReqData, setSelectedPurchaseReqData] = useState(null);
  const [openPurchaseReqAddModal, setOpenPurchaseReqAddModal] = useState(false);

  //edit Purchase Req
  const [isPurchaseReqEdit, setIsPurchaseReqEdit] = useState(false);

  const isMounted = useRef(true);
  const { showToast } = useToast();
  const { getAllUsers, allUsers } = useAllUsers();

  const {
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
  } = useConfirmationDialog();

  useEffect(() => {
    isMounted.current = true;
    getPurchaseReqData();
    getAllUsers();
    return () => {
      isMounted.current = false; // Set to false on unmount
    };
  }, []);

  const handleAddNewPurchaseReqButtonClick = () => {
    setOpenPurchaseReqAddModal(true);
    setIsPurchaseReqEdit(false);
    setSelectedPurchaseReqData(null);
  };
  const getPurchaseReqData = () => {
    dispatch({ type: FETCH_START });
    customAxios
      .get('/PO/GetRequisitions', { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          setPurchaseReqData(data.data);
          sortDataAccordingToTab(currentTab, data.data);
        } else {
          showToast('Failed to load data Purchase Requisition Data ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        // showToast('Failed to Add New Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };
  const sortDataAccordingToTab = (tabVal, data) => {
    let filtered = [];

    if (tabVal === 0) {
      // All
      filtered = data;
    } else if (tabVal === 1) {
      // Diesel Purchase
      filtered = data.filter(
        d =>
          d.purchaseOrReturn === 'Diesel Purchase' &&
          (d.requisitionStatus === 'Requested' || d.requisitionStatus === 'Ordered'),
      );
    } else if (tabVal === 2) {
      // Recharge
      filtered = data.filter(d => d.purchaseOrReturn === 'Recharge');
    } else if (tabVal === 3) {
      // BR Reports — unchanged
      filtered = data;
    } else if (tabVal === 4) {
      // Req — unchanged
      filtered = data;
    }

    setCurrentTabPurchsaseReqData(filtered);
  };

  const handlePurchseReqFormSubmit = (dataObj, typeOfForm) => {
    dispatch({ type: FETCH_START });

    customAxios
      .post('/PO/AddRequisitions', dataObj, { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          showToast('Purchase Requisition Added Successfully', 'success');
          if (dataObj.invoiceFiles) {
            addPurchaseReqDocs(data.data.newPOReqNumber, dataObj.invoiceFiles, 'invoiceFiles');
          }
          if (dataObj.files) {
            addPurchaseReqDocs(data.data.newPOReqNumber, dataObj.files, 'files');
          }
          getPurchaseReqData();
          setOpenPurchaseReqAddModal(false);
          setIsPurchaseReqEdit(false);
          setSelectedPurchaseReqData(null);
        } else {
          showToast('Failed to Add New Purchase Requisition ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        showToast('Failed to Add New Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };
  const addPurchaseReqDocs = (poReqNo, files, typeOfFile) => {
    let url = '/PO/AddRequistionsDocs';
    let formData = new FormData();
    formData.append('pO_ReqNumber', poReqNo);
    formData.append('docType', typeOfFile);
    for (let i = 0; i < files.length; i++) {
      formData.append(`file[${i}]`, files[i]);
    }
    customAxios
      .post(url, formData, { headers: authHeader() })
      .then(() => {})
      .catch(error => {
        showToast('Failed to Upload Files ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  const handleTabChange = (event, newTabVal) => {
    setCurrentTab(newTabVal);
    sortDataAccordingToTab(newTabVal, purchaseReqData);
  };

  const openEditPurchaseReqForm = reqData => {
    console.log(reqData);
    setIsPurchaseReqEdit(true);
    setSelectedPurchaseReqData({ ...reqData, column: '' });
    setOpenPurchaseReqAddModal(true);
  };

  const handleRfqEdit = reqUpdatedData => {
    dispatch({ type: FETCH_START });
    let dataObj = { ...selectedPurchaseReqData, ...reqUpdatedData };
    customAxios
      .post('/PO/EditRequisitions', dataObj, { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          showToast('Purchase Requisition Edited Successfully', 'success');
          if (dataObj.invoiceFiles) {
            addPurchaseReqDocs(data.data.newPOReqNumber, dataObj.invoiceFiles, 'invoiceFiles');
          }
          if (dataObj.files) {
            addPurchaseReqDocs(data.data.newPOReqNumber, dataObj.files, 'files');
          }
          getPurchaseReqData();
          setOpenPurchaseReqAddModal(false);
          setIsPurchaseReqEdit(false);
          setSelectedPurchaseReqData(null);
        } else {
          showToast('Failed to Edit Purchase Requisition ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        showToast('Failed to Edit Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  return {
    purchaseReqData,
    setPurchaseReqData,
    openPurchaseReqAddModal,
    setOpenPurchaseReqAddModal,
    selectedPurchaseReqData,
    setSelectedPurchaseReqData,
    handleAddNewPurchaseReqButtonClick,
    handlePurchseReqFormSubmit,
    handleTabChange,
    currentTab,
    currentTabPurchaseReqData,
    openEditPurchaseReqForm,
    isPurchaseReqEdit,
    handleRfqEdit,
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
  };
};

export default usePurchaseRequisitionController;
